<template>
  <v-group :config="groupConfig">
    <template v-if="isComplete">

      <v-text
        ref="image"
        :config="headlineTextConfig"
        v-if="stageSettings.showAllHeadlines && showHeadline"
        @click="onClickGroup"
        @mouseover="onMouseOver"
        @mouseout="onMouseOut"
        @transformend="onUpdatePosition"
        @dragend="onUpdatePosition"
        />

      <v-icon
        :x="editIconPosition.x"
        :y="editIconPosition.y"
        v-if="isSelected"
        @click="editIconClick"
        iconName="editHeadlieIcon"
        iconType="edit" />

    </template>
  </v-group>
</template>

<script>
import VIcon from './VIcon'
import CommitmentMixin from '@/components/Inline/CommitmentMixin'
import debounce from 'lodash.debounce';
import clonedeep from 'lodash.clonedeep'

const SAVE_GOAL_POSITION_THROTTLE_TIME = 1000;

export default {
  props: ['goal_id', 'goal_meta', 'stageSettings', 'isSelected'],
  mixins: [CommitmentMixin],
  data: () => ({
  }),
  watch: {
    goal_meta( newValue ) {
      // take care of z-index
    }
  },
  computed: {
    // ...mapGetters("goal", [
    //   "goal_is_ready"
    // ]),

    isComplete() {
      return this.$api.get_ready( 'goal', this.goal_id )
    },

    showHeadline() {
      let userGoal = this.goal_meta;
      return userGoal.graphicalRepresentation.showHeadline;
    },

    groupConfig() {
      // let userGoal = this.goal_meta;
      return {
        draggable:  false,
        x:          0, // userGoal.graphicalRepresentation.x,
        y:          0, // userGoal.graphicalRepresentation.y,
        rotation:   0, // userGoal.graphicalRepresentation.rotation,
        scaleX:     1, // userGoal.graphicalRepresentation.scaleX,
        scaleY:     1, // userGoal.graphicalRepresentation.scaleY,
      }
    },

    editIconPosition() {
      let userGoal = this.goal_meta;
      return {
        x:          userGoal.graphicalRepresentation.headline.x - 30,
        y:          userGoal.graphicalRepresentation.headline.y - 20,
      }
    },

    headlineTextConfig() {
      let userGoal = this.goal_meta;
      let headline = Object.assign({
        draggable:  true,
        text:       userGoal.cachedName,
        fontSize:   this.stageSettings.allHeadlinesFontSize,
        x:          userGoal.graphicalRepresentation.headline.x,
        y:          userGoal.graphicalRepresentation.headline.y,
        rotation:   userGoal.graphicalRepresentation.headline.rotation,
        scaleX:     userGoal.graphicalRepresentation.headline.scaleX,
        scaleY:     userGoal.graphicalRepresentation.headline.scaleY,
        align: "left",
        fill: '#ffffff',
      });
      // }, userGoal.graphicalRepresentation.headline); // TODO: be able to remove fontSize
      /* = fontFamily, fontSize */

      return headline;
    },
  },
  methods: {

    onUpdatePosition: debounce(function (event) {

      console.log("dragGroup", event);

      let positionData = {
        x: parseInt( event.target.attrs.x ),
        y: parseInt( event.target.attrs.y ),
        scaleX: ( event.target.attrs.scaleX ),  // NEU
        scaleY: ( event.target.attrs.scaleY ),  // NEU
        rotation: parseInt( event.target.attrs.rotation ),  // NEU
      }

      // --> MIXIN
      const between = (min,v,max) => Math.max( min, Math.min(v, max) );
      positionData.scaleX = between(0.1, positionData.scaleX, 3.0);
      positionData.scaleY = between(0.1, positionData.scaleY, 3.0);
      positionData.x = between(0, positionData.x, this.stageSettings.width);
      positionData.y = between(0, positionData.y, this.stageSettings.height);

      if ( positionData.scaleX !== positionData.scaleY ) {
        console.log("I think aspect ratio should always stay the same, no?");
        positionData.scaleX = positionData.scaleY;
      }

      /* Workaround due to limitation that update_user_goal only supports
         nested data merge up to 1 level */
      let data = Object.assign({},
        this.goal_meta.graphicalRepresentation,
        {
          headline: {
            ...positionData, // NEU
            fontFamily: "Arial",
            fontSize: 24,
          }
        }
      );
      data = clonedeep(data);
      console.log({ graphicalRepresentation: data });
      this.$api.update_user_goal({ data: { graphicalRepresentation: data }, goal_id: this.goal_id });
      // ^ TODO

    }, SAVE_GOAL_POSITION_THROTTLE_TIME),

    // --> MIXIN
    onClickGroup(event) {
      let node = this.$refs.image.getNode();
      // let node = this.$refs.group.getNode();
      console.log("click group", { goalId: this.goal_id, node: node, event, type: 'headline' });
      this.$emit('click-group', { goalId: this.goal_id, node: node, event, type: 'headline' });
    },

    // --> MIXIN
    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },

    // --> MIXIN
    onMouseOut(event) {
      document.body.style.cursor = 'default';
    },

    // --> MIXIN
    editIconClick(event) {
      console.log("editIconClickeditIconClickeditIconClick");
      this.$emit('select-image', { goalId: this.goal_id, event });
    },
  },
  components: {
    VIcon
  }
}
</script>
